import { render, staticRenderFns } from "./PromoAreaCard.vue?vue&type=template&id=f98e882e&scoped=true"
import script from "./PromoAreaCard.vue?vue&type=script&lang=js"
export * from "./PromoAreaCard.vue?vue&type=script&lang=js"
import style0 from "./PromoAreaCard.vue?vue&type=style&index=0&id=f98e882e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f98e882e",
  null
  
)

export default component.exports